import { PropsWithChildren } from 'react';
import styles from './stack.module.scss';
import clsx from 'clsx';
import { GapValues } from './Grid';

interface StackProps {
  /**
   * Whether to display elements in a row, or to use the default column layout.
   */
  row?: boolean;
  /**
   * Whether to wrap elements using flexbox
   */
  wrap?: boolean;
  /**
   * The gap between elements as a multiple of 8px on larger screens, and 4px for smaller screens. Defaults to 2
   */
  gap?: GapValues;
  /**
   * CSS Classname to style the div
   */
  className?: string;
}

export const Stack = ({
  row = false,
  wrap = false,
  gap = 2,
  className,
  children
}: PropsWithChildren<StackProps>) => {
  const gapStyle = styles[`gap${gap}`];
  return (
    <div
      className={clsx(styles.stack, gapStyle, row && styles.row, wrap && styles.wrap, className)}
    >
      {children}
    </div>
  );
};
